// Require compiled modernizr.js before application loads.
require('@/services/modernizr')

import Vue from 'vue'

// Auto loaders
import '@/components'
import '@/plugins'
import '@/directives'

import app from './app.vue'
import store from '@/services/store/store'
import router from '@/services/router/router'
import { i18n } from '@/services/i18n/i18n'

import 'quill/dist/quill.snow.css'
import './assets/styles/main.scss'

new Vue({
  el: '#app',
  store,
  router,
  i18n,

  // Call `Appcues.page()` once the URL has updated
  watch: {
    $route: {
      handler() {
        // @ts-ignore
        window.Appcues.page()
      },
    },
  },

  render: h => h(app),
})
